import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useEditFunnel } from '../../api/editFunnel';
import { Fields } from '../../hooks/useEditFunnelForm';

import { FunnelForm } from './Form';

type Props = {
  pageId: string;
  funnelId: string;
  initialValues: Fields;
};

export const EditFunnelModal = NiceModal.create(({ pageId, funnelId, initialValues }: Props) => {
  const modal = useModal();

  const { mutate, isLoading } = useEditFunnel({ pageId, onSuccess: modal.hide });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={modal.remove}
      title="Edit funnel"
    >
      <FunnelForm
        isLoading={isLoading}
        onSubmit={(params) => mutate({ ...params, _id: funnelId })}
        initialValues={initialValues}
      />
    </Modal>
  );
});
